import { Button, Modal } from "react-bootstrap";
import "./add-candidate.modal.scss";
import { CircularProgress, Divider, FormControl, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Candidate } from "../model/candidate.model";
import { useFilePicker } from "use-file-picker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import dayjs, { Dayjs } from "dayjs";
import PLUS_DARK_ICON from "../assets/images/plus-dark.png"
import { getSummaryResume, uploadResume } from "../services/api.service";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
interface AddCandidateProps {
    onSubmit(candidate: Candidate): void; // ✅ Pass the summary object
    isOpen: boolean;
    onClose(): void;
    isSubmittingStatus: boolean;
}

const AddCandidateModal: React.FC<AddCandidateProps> = ({ onSubmit, isOpen, onClose, isSubmittingStatus }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [resumeKey, setResumeKey] = useState('');
    const [messageLoad, setMessageLoad] = useState("กำลังอัปโหลด Resume.. <br> กรุณารอสักครู่...")
    const [formList, setFormList] = useState([
        { label: "ชื่อ", field: "firstname", value: "", is_error: true, error_message: "กรุณากรอกชื่อ" },
        { label: "นามสกุล", field: "lastname", value: "", is_error: true, error_message: "กรุณากรอกนามสกุล" },
        { label: "อีเมล", field: "email", value: "", is_error: true, error_message: "กรุณากรอกอีเมล" },
        { label: "เบอร์โทรศัพท์", field: "phone", value: "", is_error: true, error_message: "กรุณากรอกเบอร์" },
        { label: "ตำแหน่งงานปัจจุบัน (ไม่บังคับ)", field: "job_title", value: "", is_error: false, error_message: "" },
        { label: "ประสบการณ์ทั้งหมด (ไม่บังคับ)", field: "job_exp", value: "", is_error: false, error_message: "" },
        { label: "วันที่เริ่มสัมภาษณ์", field: "start_date", value: new Date().toISOString(), is_error: false, error_message: "กรุณาระบุวันสัมภาษณ์" },
        { label: "วันสิ้นสุดการสัมภาษณ์", field: "end_date", value: new Date().toISOString(), is_error: false, error_message: "กรุณาระบุวันสัมภาษณ์" },

    ])
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [isUploading, setIsUploading] = useState(false);

    const { openFilePicker } = useFilePicker({
        multiple: false,
        readAs: 'DataURL',
        accept: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', '.doc', ".docx"],
        limitFilesConfig: { min: 0, max: 1 },
        maxFileSize: 20,
        onFilesSelected: ({ plainFiles }) => {
            setFileUpload(plainFiles[0]);
            setResumeKey(plainFiles[0]?.name || '');
        }
    });

    useEffect(() => {
        setIsUploading(false);
        if (isSubmittingStatus) {

            setIsSubmitting(isSubmittingStatus);
        }
    }, [isSubmittingStatus])



    const handleInputChange = (event: any, field: string, index) => {
        const value = event.target.value;
        if (formList) {
            const formListMod = [...formList];
            formListMod[index].value = value;
            formListMod[index].is_error = false;
            formListMod[index].error_message = "";
            setFormList(formListMod);
        }

    };

    const handleDateChange = (value, index) => {
        if (formList) {
            const formListMod = [...formList];
            formListMod[index].value = new Date(value).toISOString();
            formListMod[index].is_error = false;
            formListMod[index].error_message = "";
            setFormList(formListMod);
        }
    }



    const parseJobExp = (raw: string): number => {
        if (raw === "" || raw == null) return 0;
        const n = Number(raw);
        return Number.isFinite(n) ? n : 0;
    };

    const phoneValue = () => String(formList[3]?.value ?? "").trim();

    const handleSubmitCandidate = () => {
        setIsSubmitting(true);
        if (fileUpload && formList[0].value
            && formList[1].value && formList[2].value
            && phoneValue() && formList[6].value
            && formList[7].value) {
            setIsUploading(true);
            try {
                uploadResume(fileUpload, fileUpload.name).then((resUpload) => {

                    if (resUpload.resume_key) {
                        setMessageLoad("กำลังสรุปข้อมูลของคุณ <br> กรุณาอย่าปิดหน้านี้โดยเด็ดขาด")
                        getSummaryResume(resUpload.resume_key).then((res) => {

                            if (res.summary) {

                                const newCandidate: Candidate = {
                                    firstname: formList[0].value,
                                    lastname: formList[1].value,
                                    email: formList[2].value,
                                    phone: phoneValue(),
                                    status: "ACTIVE",
                                    jobTitle: String(formList[4].value ?? "").trim(),
                                    interview_start_date: formList[6].value + "",
                                    interview_end_date: formList[7].value + "",
                                    jobExp: parseJobExp(String(formList[5].value ?? "")),
                                    resume: { key: resUpload.resume_key, filename: fileUpload.name, summary: res.summary, skills: res.skills },
                                    candidate_id: ""
                                };
                                setIsSubmitting(false);
                                onSubmit(newCandidate); // ✅ Pass candidate data
                                onClose();
                                setIsUploading(false);
                            }
                        })
                    }

                })
            } catch {
                setIsUploading(false);
            }

        } else if (!fileUpload && formList[0].value
            && formList[1].value && formList[2].value
            && phoneValue() && formList[6].value
            && formList[7].value) {
            setIsUploading(true);
            const newCandidate: Candidate = {
                firstname: formList[0].value,
                lastname: formList[1].value,
                email: formList[2].value,
                phone: phoneValue(),
                status: "ACTIVE",
                jobTitle: String(formList[4].value ?? "").trim(),
                interview_start_date: formList[6].value + "",
                interview_end_date: formList[7].value + "",
                jobExp: parseJobExp(String(formList[5].value ?? "")),
                resume: null,
                candidate_id: ""
            };
            setIsSubmitting(false);
            onSubmit(newCandidate); // ✅ Pass candidate data
            onClose();
            setIsUploading(false);
        } else {
            setIsSubmitting(false);
        }
        // const newCandidate: Candidate = {
        //     firstname: formList[0].value,
        //     lastname: formList[1].value,
        //     email: formList[2].value,
        //     phone: formList[3].value,
        //     jobTitle: formList[4].value,

        //     interview_start_date: formList[6].value + "",
        //     interview_end_date: formList[7].value + "",
        //     jobExp: Number(formList[5].value),
        //     resume: null,
        //     candidate_id: ""
        // };
        // console.log("🎯 Candidate Data Submitted:", newCandidate);
        // onSubmit(newCandidate); // ✅ Pass candidate data
    };
    const removeFile = () => {
        setFileUpload(null);
        setResumeKey('');
    }
    return (
        <>
            <Modal centered show={isOpen} onHide={onClose} className="add-candidate-control">
                <Modal.Body>
                    <div className="add-candidate-item-control">
                        {
                            isUploading ?
                                <>
                                    <div className="add-candidate-loading-control">
                                        <div className="add-candidate-loading-item">
                                            <CircularProgress className="add-candidate-loading-progress"></CircularProgress>
                                            <div className="add-candidate-loading-text" dangerouslySetInnerHTML={{ __html: messageLoad }}></div>

                                        </div>

                                    </div>
                                </> :

                                <>
                                    <div className="add-candidate-title-control">
                                        <img src={PLUS_DARK_ICON} className="icon"></img>
                                        <span className="add-candidate-title">เพิ่มผู้สมัคร</span>
                                    </div>
                                    <span className="add-candidate-sub-title">เมื่อเพิ่มข้อมูลผู้สมัครแล้ว ระบบจะส่งอีเมลแจ้งรายละเอียดการสัมภาษณ์ไปยังผู้สมัครโดยอัตโนมัติทันที</span>


                                    {/* 🔹 Personal Info */}
                                    <div className="add-candidate-topic-control">
                                        <div className="d-flex">
                                            <div className="icon"></div>
                                            <span className="add-candidate-topic-title">ข้อมูลผู้สมัคร</span>
                                        </div>
                                    </div>
                                    <div className="add-candidate-grid-control">
                                        {formList.map((item, index) => {
                                            // Skip fields at index 6 and 7
                                            if (index === 6 || index === 7) return null;

                                            const hasError = isSubmitting && item.is_error;
                                            return (
                                                <FormControl
                                                    key={index}
                                                    className={`input-std${hasError ? " input-error" : ""}`}
                                                    fullWidth
                                                >
                                                    <TextField
                                                        id={`input-${index}`}
                                                        type={index === 5 ? "number" : index === 2 ? "email" : "text"}
                                                        label={item.label}
                                                        variant="outlined"
                                                        value={item.value}
                                                        onChange={(e) => handleInputChange(e, item.field, index)}
                                                        inputProps={index === 3 ? { inputMode: "tel" } : undefined}
                                                    />
                                                </FormControl>
                                            );
                                        })}

                                    </div>
                                    <div className="add-candidate-topic-control">
                                        <div className="d-flex">
                                            <div className="icon"></div>
                                            <span className="add-candidate-topic-title">อัปโหลดเรซูเม่ผู้สมัคร</span>
                                        </div>
                                    </div>
                                    {
                                        (fileUpload) ?
                                            <div className="form-upload-file-control" style={isSubmitting && !fileUpload ? { border: "2px dashed red" } : {}}>
                                                <div className="form-upload-text-control">
                                                    <span className="form-upload-text">{fileUpload.name}</span>
                                                </div>
                                                <FontAwesomeIcon icon={faTrash} className="form-upload-trash"
                                                    onClick={removeFile}></FontAwesomeIcon>
                                            </div> :
                                            <div className="form-upload-file-control" >
                                                <div className="form-upload-text-control">
                                                    <span className="form-upload-text">คลิกอัปโหลดเพื่อเพิ่มไฟล์</span>
                                                    <span className="form-upload-desc">ไฟล์ที่รองรับ: .pdf, .doc, .docx, .xlxs | ขนาดไม่เกิน 25MB</span>
                                                </div>
                                                <Button className="form-upload-button" onClick={openFilePicker}>อัปโหลดไฟล์</Button>
                                            </div>
                                    }

                                    <div className="add-candidate-topic-control">
                                        <div className="d-flex">
                                            <div className="icon"></div>
                                            <span className="add-candidate-topic-title">ข้อมูลวันสัมภาษณ์</span>
                                        </div>
                                        <span className="add-candidate-sub-topic">เพิ่มระยะเวลาการสัมภาษณ์ หากเกินวันสิ้นสุดผู้สมัครจะไม่สามารถใช้งานลิงก์การสัมภาษณ์ได้</span>
                                    </div>
                                    <div className="add-candidate-grid-control">
                                        <FormControl className={isSubmitting && formList[6].is_error ? "input-std  input-error" : "input-std"} fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker']}>
                                                    <DatePicker className="form-date-picker" label={formList[6].label} name={formList[6].label}
                                                        value={dayjs(formList[6].value)}
                                                        minDate={dayjs()} // ✅ Set min date to today
                                                        onChange={(newValue) => handleDateChange(newValue, 6)} />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </FormControl>
                                        <FormControl className={isSubmitting && formList[7].is_error ? "input-std  input-error" : "input-std"} fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker']}>
                                                    <DatePicker className="form-date-picker" label={formList[7].label} name={formList[7].label}
                                                        value={dayjs(formList[7].value)}
                                                        minDate={dayjs()}
                                                        onChange={(newValue) => handleDateChange(newValue, 7)} />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </FormControl>
                                    </div>


                                    {/* 🔹 Action Buttons */}
                                    <div className="add-candidate-button-control">
                                        <Button className="add-candidate-button-cancel" onClick={onClose}>ยกเลิก</Button>
                                        <Button className="button-std add-candidate-button-submit" onClick={handleSubmitCandidate}>ยืนยัน</Button>
                                    </div>
                                </>
                        }

                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddCandidateModal;
